import { cx } from './cx.js';

export function Spinner({ className }: { className?: string }) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={cx(
        'inline-block h-5 w-5 animate-spin rounded-full border-2 border-slate-300',
        'border-t-viana-secondary',
        className,
      )}
    />
  );
}
